<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="店铺名" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="房间号" prop="roomNumber">
                <a-input v-model="queryParam.roomNumber" placeholder="请输入房间号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否公开" prop="isPublic">
                <a-select v-model="queryParam.isPublic" placeholder="请选择是否公开" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否删除" prop="isDeleted">
                <a-select v-model="queryParam.isDeleted" placeholder="请选择是否删除" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="6" :sm="24" style="float: right">
              <span class="table-page-search-submitButtons" :style="{ float: 'right', overflow: 'hidden' }">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['played:room/clue/relation:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="isPublic" slot-scope="text, record">
          <a-tag v-if="!record.isPublic" color="green">否</a-tag>
          <a-tag v-if="record.isPublic" color="red">是</a-tag>
        </template>
        <template slot="isDeleted" slot-scope="text, record">
          <a-tag v-if="!record.isDeleted" color="green">否</a-tag>
          <a-tag v-if="record.isDeleted" color="red">是</a-tag>
        </template>
        <div slot="clueImage" slot-scope="text, record">
          <img :src="record.clueImage" style="width:100px; cursor: pointer;" preview alt=""/>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['played:script/material:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        :show-quick-jumper="false"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRoomClueImg, remove } from '@/api/played/roomClue'
import { tableMixin } from '@/store/table-mixin'
import Dept from '@/views/system/dept/index.vue'

export default {
  name: 'RoomClue',
  components: {
    Dept
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        isPublic: null,
        shopName: null,
        roomNumber: null,
        isDeleted: null
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'DM名',
          dataIndex: 'dmName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '房间号',
          dataIndex: 'roomNumber',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店铺名',
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否公开',
          dataIndex: 'isPublic',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isPublic' }
        },
        {
          title: '图片线索',
          dataIndex: 'clueImage',
          scopedSlots: { customRender: 'clueImage' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '是否删除',
          dataIndex: 'isDeleted',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isDeleted' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询银河打本剧本宣传物料列表 */
    getList () {
      this.loading = true
      pageRoomClueImg(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        isPublic: null,
        shopName: null,
        roomNumber: null,
        isDeleted: null
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return remove(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
